import React from 'react';
import styled from 'styled-components';

const GridCellContainer = styled.div<{h: string, g: number, jc: string}>`
  flex-grow: ${({ g }) => g};
  height: ${({ h }) => h || 'auto'};
  justify-content: ${({ jc }) => jc};
  display: flex;
  flex-flow: column;
`;

interface GridCellProps {
  children: any,
  height: string,
  grow: number,
  placementItems: 'flex-start' | 'flex-end' | 'center',
}

function GridCell({
  children, height, grow,
  placementItems,
}: GridCellProps) {
  return (
    <GridCellContainer h={height} g={grow} jc={placementItems}>
      { children }
    </GridCellContainer>
  );
}

export default GridCell;

GridCell.defaultProps = {
  children: null,
  height: null,
  grow: 1,
  placementItems: 'flex-start',
}
